import HeroComponent from "../../../ui/heroComponent";

const LoansHeroSection = () => {
  return <HeroComponent heading1="Loans" />;
};

export default LoansHeroSection;
